import {Util} from './util';

export class Error {

	constructor(public id: string) {
	}

	public static fromJSON(json: string): Error {
		return Util.getTypedResponse<Error>(json, Error.prototype);
	}
}

